import { useCallback } from 'react';

export interface TableSettings {
  visible_columns: string[];
  sort_by: string | null;
  sort_order: 'asc' | 'desc';
  filters: Record<string, string | string[]>;
  column_widths: Record<string, number>;
  page_size: number;
}

interface SettingsResponseOptional {
  success: boolean;
  data: TableSettings | null;
}

/**
 * Stub-Hook — pm-api hat keinen user-settings-Endpoint. EnhancedDataTable
 * kann ohne persistierte Settings auskommen (lokaler State pro Mount).
 * Wenn pm-api spaeter PUT/GET /api/v1/user-settings/tables/:id bekommt,
 * kann hier wieder ein useQuery rein.
 */
export function useTableSettings(_tableId: string): {
  data: SettingsResponseOptional;
  isLoading: false;
  isError: false;
} {
  return {
    data: { success: false, data: null },
    isLoading: false,
    isError: false,
  };
}

export function useSaveTableSettings(_tableId: string) {
  const saveDebounced = useCallback((_settings: Partial<TableSettings>) => {
    // no-op solange pm-api keinen user-settings-Endpoint hat
  }, []);
  return { saveDebounced };
}
